/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
import {resolveForwardRef} from '../forward_ref';
import {ÉµÉµinject, ÉµÉµinvalidFactoryDep} from '../injector_compatibility';
import {ÉµÉµdefineInjectable, ÉµÉµdefineInjector} from '../interface/defs';

/**
 * A mapping of the @angular/core API surface used in generated expressions to the actual symbols.
 *
 * This should be kept up to date with the public exports of @angular/core.
 */
export const angularCoreDiEnv: {[name: string]: Function} = {
  'ÉµÉµdefineInjectable': ÉµÉµdefineInjectable,
  'ÉµÉµdefineInjector': ÉµÉµdefineInjector,
  'ÉµÉµinject': ÉµÉµinject,
  'ÉµÉµinvalidFactoryDep': ÉµÉµinvalidFactoryDep,
  'resolveForwardRef': resolveForwardRef,
};
